import { actions } from "@shared/template/StoreTemplates/FilterStoreTemplate"
import * as leadService from "@hub/leads/src/services/leads.service"
import { IMPORTATION_STATUS } from "@hub/leads/src/constants"

export default {
  ...actions,
  async fillLead({ state, commit }) {
    const { lead } = await leadService.get(state.leadToEditId)

    const rawComplement = lead.address?.complement

    const complement = Array.isArray(rawComplement)
      ? rawComplement[0]
      : null

    const leadToFill = {
      type: lead.identification.person_type,
      document: lead.identification.document,
      name: lead.identification.name,
      birthDate: lead.identification?.birth_or_founding_date?.split("-")?.reverse()?.join(" / "),
      mainPhone: lead.contact.main_phone,
      secondaryPhone: lead.contact.secondary_phone || "",
      email: lead.contact.email,
      cep: lead.address.cep,
      street: lead.address.street,
      number: lead.address?.number?.toString(),
      noNumber: lead.address?.number ? false : true,
      complementType: complement?.type || "",
      complement: Array.isArray(rawComplement)
        ? complement?.value || ""
        : rawComplement || "",
      neighborhood: lead.address.neighborhood,
      state: `${lead.address.state_name} - ${lead.address.state_letter}`,
      city: lead.address.city_name,
      cityId: lead.address.city_uuid,
      referencePoint: lead.address.reference_point,
      status: lead.status.value,
      tags: lead.tags?.map(tag => tag.value) || [],
      note: lead.notes,
    }

    const disabledFields = {
      type: leadToFill.type ? true : false,
      document: leadToFill.document ? true : false,
      name: leadToFill.name ? true : false,
      birthDate: leadToFill.birthDate ? true : false,
      mainPhone: leadToFill.mainPhone ? true : false,
      secondaryPhone: leadToFill.secondaryPhone ? true : false,
      email: leadToFill.email ? true : false,
      cep: leadToFill.cep ? true : false,
      street: leadToFill.street ? true : false,
      number: leadToFill.number ? true : false,
      noNumber: true,
      complementType: leadToFill.complementType ? true : false,
      complement: leadToFill.complement ? true : false,
      neighborhood: leadToFill.neighborhood ? true : false,
      state: leadToFill.state ? true : false,
      cityId: leadToFill.city ? true : false,
      referencePoint: leadToFill.referencePoint ? true : false,
      status: leadToFill.status ? true : false,
      tags: leadToFill.tags.length ? true : false,
      note: leadToFill.note ? true : false,
    }

    commit("updateLead", leadToFill)
    commit("setDisabledFieldToEdit", disabledFields)
  },

  async startPolling({ state, commit }, uuid) {
    if (state.polling) {
      clearInterval(state.polling)
      commit("setPolling", null)
    }

    return new Promise((resolve, reject) => {
      const polling = setInterval(async () => {
        try {
          const params = { uuid }
          const data = await leadService.verifyImportationStatus(params)

          commit("setLastImportation", data.importation)

          if (
            data.importation.importation_status === IMPORTATION_STATUS.success ||
            data.importation.importation_status === IMPORTATION_STATUS.failed
          ) {
            clearInterval(polling)
            commit("setPolling", null)

            window.dispatchEvent(
              new CustomEvent("lead-import-finished")
            )

            window.$vue.$toast({
              type: data.importation.importation_status === IMPORTATION_STATUS.success
                ? "success"
                : "error",
              title: data.importation.importation_status === IMPORTATION_STATUS.success
                ? "Importação de leads concluída!"
                : "Importação de leads falhou!"
            })

            resolve(data.importation)
          }
        } catch (error) {
          clearInterval(polling)
          commit("setPolling", null)

          reject(error)
        }
      }, 15000)

      commit("setPolling", polling)
    })
  }
}
